export default {
  // Base Catalog API
  /**
   *
   * @param state
   * @param property
   * @param payload
   */
  setProperty(state, { property, payload }) {
    state[property] = payload;
  },

  /**
   *
   * @param state
   * @param payload
   */
  setSocketMessage(state, payload) {
    state.socketMessages.push(payload);
  },

  /**
   *
   * @param state
   * @param payload
   */
  setBaseData(state, payload) {
    state.baseData = payload;
  },

  /**
   *
   * @param state
   */
  setCategory(state) {
    state.categories = state.baseData.map(category => ({
      id: category.id,
      name: category.name,
      image: category.image,
      description: category.description,
      homepage_feature: category.homepage_feature,
    }));
  },

  /**
   *
   * @param state
   */
  setSubCategory(state) {
    let data = {};
    state.baseData.forEach((category) => {
      const subCategories = category.subcategories.map(subCategory => ({
        id: subCategory.id,
        category: category.name,
        category_id: category.id,
        name: subCategory.name,
        description: subCategory.description,
        image: subCategory.image,
        homepage_feature: subCategory.homepage_feature,
      }));

      data = { ...data, ...{ [category.id]: subCategories } };
    });

    state.subCategories = data;
  },

  /**
   *
   * @param state
   */
  setMicroCategory(state) {
    let data = {};
    state.baseData.forEach((category) => {
      category.subcategories.forEach((subCategory) => {
        const microCategories = subCategory.microCategories.map(microCategory => ({
          id: microCategory.id,
          category: category.name,
          category_id: category.id,
          subCategory: subCategory.name,
          sub_category_id: subCategory.id,
          name: microCategory.name,
          description: microCategory.description,
          image: microCategory.image,
        }));

        data = { ...data, ...{ [subCategory.id]: microCategories } };
      });
    });

    state.microCategories = data;
  },

  setCurrentSelected(state, { property, payload }) {
    state.currentSelected[property] = payload;
  },
};
